import { useCreateCheckoutPay, useGetAuthMe } from "@birdwatch/client";

import { useRefresh } from "@/features/shared/realtime-refresh";

export const useCheckout = () => {
  const refresh = useRefresh();
  const { data: me } = useGetAuthMe().get();
  const mutation = useCreateCheckoutPay({
    // The charge opens the account's subscription and membership. The route
    // also announces `purchaseIntent.changed` (team channel only), but the paid
    // intent must not be re-read under an open checkout: both funnels leave the
    // page once `stripeInvoiceId` is set, which would cut the success modal short.
    onSuccess: (subscription) => {
      const accountId = me?.accounts?.[0]?.id ?? null;
      void Promise.all([
        refresh("subscription.changed", {
          subscriptionId: subscription.databaseId,
          accountId,
        }),
        refresh("membership.changed", {
          membershipId: subscription.membershipId,
          accountId,
        }),
      ]);
    },
  });
  const run = (purchaseIntentId: string) =>
    mutation.mutateAsync({ purchaseIntentId });

  return { ...mutation, mutate: run, mutateAsync: run };
};
